export default __webpack_public_path__ + "static/visual_3-cf0d94cc723d0df3b51c92d40c2f9b44.jpg";